<app-toast-message [justAfterLogin]="false"></app-toast-message>
<div class="container">

  <div class="row justify-content-center align-items-center taxonomies-creation w-100">
    <section class="col-md-11 col-lg-10 col-xl-8">
      <h1 class="font-bold font-5x">How about a quick review?</h1>
      <p>A quick review and you are all set!</p>

      <h2 class="font-bold font-4x" [innerHtml]="taxonomyName"></h2>

      <ng-container *ngIf="summaryDetail">
        <div class="col-12 p-0">
          <div class="col-12 imported-summary">
            <div class="row imported-summary--heading">
              <div class="col-8">
                <h3 class="font-bold font-3x">Here's a summary of your import</h3>
              </div>
            </div>

            <div class="row align-items-center text-center justify-content-center">
              <div class="col-3" *ngIf="importType !== 4">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">1</h4>
                  <p class="col-12 total-info font-bold">Taxonomy <span>Created</span></p>
                </div>
              </div>

              <div class="col-3">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['new_node_count']}}
                  </h4>
                  <p class="col-12 total-info font-bold">Nodes
                    <span>Created</span>
                  </p>
                </div>
              </div>
              <div class="col-3" *ngIf="importType !== 1 && importType !== 2">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['updated_node_count']}}
                  </h4>
                  <p class="col-12 total-info font-bold">Nodes
                    <span>Updated</span>
                  </p>
                </div>
              </div>

              <div class="col-3" *ngIf="importType !== 1 && importType !== 2">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['delete_node_count']}}</h4>
                  <p class="col-12 total-info font-bold">Nodes
                    <span>Deleted</span>
                  </p>
                </div>
              </div>

              <div class="col-3">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['new_associations_count']}}</h4>
                  <p class="col-12 total-info font-bold">Associations
                    <span>Created</span>
                  </p>
                </div>
              </div>

              <div class="col-3" *ngIf="importType !== 1 && importType !== 2">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['deleted_associations_count']}}</h4>
                  <p class="col-12 total-info font-bold">Associations
                    <span>Deleted</span>
                  </p>
                </div>
              </div>

              <div class="col-3" *ngIf="importType !== 1 && importType !== 2">
                <div class="row align-items-center" aria-live="polite" aria-atomic="true">
                  <h4 class="col-12 total font-bold">
                    {{summaryDetail['new_metadata_count']}}</h4>
                  <p class="col-12 total-info font-bold">New Metadata
                    <span>Count</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- end of imported summary -->
        </div>

        <!-- Updated Node Info -->
        <div class="col-12 p-0">
          <div class="imported-summary-nodes w-100" *ngIf="summaryDetail['metadata']?.length">
            <div class="user-listing-panel col-12 mt-0">
              <div class="col-lg-12 col-sm-12">
                <div class="row user-header-row d-flex justify-content-between">
                  <div class="col-12 header p-0">
                    <h3 class="font-bold font-3x">Metadata Summary</h3>
                  </div>
                </div>

                <div class="row">
                  <table class="w-100 mb-2 border-bottom">
                    <caption class="sr-only">Metadata summary details view</caption>
                    <thead>
                      <tr class="d-flex">
                        <th scope="col" class="col p-0 text-wrapped lock-cell">Metadata field</th>
                        <th scope="col" class="col p-0 text-wrapped lock-cell">Old value</th>
                        <th scope="col" class="col p-0 text-wrapped lock-cell">New value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let nodeItem of summaryDetail['metadata']; let i = index;">
                        <tr class="d-flex">
                          <td colspan="3" class="text-wrapped w-100">
                            <h4 class="font-bold font-2x" [innerHtml]="nodeItem?.item_name" ></h4>
                          </td>
                        </tr>

                        <ng-container *ngFor="let metadataFields of nodeItem.metadata_fields; let i = index;">
                          <tr class="d-flex">
                            <td class="col p-0 text-wrapped lock-cell">{{metadataFields?.name}}</td>
                            <td class="col p-0 text-wrapped lock-cell" [innerHtml]="metadataFields?.old_value"></td>
                            <td class="col p-0 text-wrapped lock-cell" [innerHtml]="metadataFields?.new_value"></td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
            <!-- End of updated node info-->
          </div>

          <div class="col-12 border py-3" *ngIf="errorData && errorData.length">
            <div class="col-12 p-0">
              <h4 class="font-bold font-2x" id="errorSummary">Error Summary</h4>
            </div>
            <div class="col-12">
              <table class="w-100" aria-labelledby="errorSummary">
                <thead>
                  <tr class="d-flex">
                    <th scope="col" class="col p-0 text-wrapped lock-cell">Error</th>
                    <th scope="col" class="col p-0 text-wrapped lock-cell">Row</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let error of errorData">
                    <tr class="border-bottom d-flex">
                      <td class="col p-0 text-wrapped lock-cell">{{error?.Error}}</td>
                      <td class="col p-0 text-wrapped lock-cell">{{error?.Row}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div class="footer-buttons col-12 d-flex justify-content-center my-3">
          <button *ngIf="isPreSummary" class="btn btn-cancel text-underline mr-2" type="button"
            (click)="cancelImport()">Don't Proceed! I
            want to try again.</button>

          <button class="btn btn-primary btn-lg" id="closeButton" type="button"
            (click)="onProceed();">{{isPreSummary ? 'Proceed' : 'Finish'}}</button>
        </div>


      </ng-container>
    </section>
  </div>
</div>